// A plus, for the "New space" primary. Inline SVG like every other icon here —
// there is no icon dependency (CLAUDE.md).
export default function PlusIcon({ size = 16 }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.75"
      strokeLinecap="round"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M8 2.5v11M2.5 8h11" />
    </svg>
  )
}
